"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var TextField_1 = require("../../../../../common/TextField");
var OriginalAmountFields = function (props) {
    var _a = __read(React.useState('25.00'), 2), originalAmount = _a[0], setOriginalAmount = _a[1];
    var initialized = React.useRef(false);
    // This effect runs on the edit debt screen.
    // This ensures that if the debt is being edited ("reverted"), we set the displayed amount to the original submitted value
    // rather than the default £25.00.
    React.useEffect(function () {
        if (props.status === 'reverted' && props.values.original_amount != null) {
            setOriginalAmount(props.values.original_amount);
        }
    }, [props.status, props.values.original_amount]);
    // This effect runs on the new debt wizard.
    // This effect ensures that if a user has already entered an original amount earlier in the wizard
    // (for example, on the debt details page), that value persists when this component renders later in the wizard
    // (for example, on the confirmation page). Without this, the input would reset to the default £25.00
    //  when navigating from one page to another.
    //
    // We use a `useRef` flag (`initialized`) to make sure this effect runs only once per debt load.
    // Why? Because calling `setOriginalAmount` triggers the next useEffect below, which updates Formik’s value
    // via `setFieldValue`. Without our useRef, this would create an endless loop:
    // 1. Effect runs -> sets `originalAmount` -> triggers next effect -> updates Formik and prop values -> first effect runs again -> repeat.
    //
    React.useEffect(function () {
        if (!initialized.current && props.status !== 'reverted' && props.values.original_amount != null) {
            setOriginalAmount(String(props.values.original_amount));
            initialized.current = true;
        }
    }, [props.status, props.values.original_amount]);
    React.useEffect(function () {
        props.setFieldTouched('original_amount', true);
        props.setFieldValue('original_amount', originalAmount);
    }, [originalAmount]);
    return (React.createElement("div", { className: "original-amount-input flex-row" },
        React.createElement("span", { className: "currency-symbol" }, "\u00A3"),
        React.createElement(TextField_1.default, { type: "string", name: "original_amount", validator: props.validator, value: originalAmount, onChange: function (value) {
                setOriginalAmount(value);
            }, className: "original-amount-input-full", disabled: false })));
};
exports.default = OriginalAmountFields;
